import React, { useState } from "react";
import style from "./index.module.scss";
import {
    getGroupActivityTaskHomeworkForCheck,
    GroupAnswerViewItem,
    TaskFileEntityListItem
} from "../../../../../service/group";
import useRequest from "../../../../../utils/useRequest";
import FileList from "./Components/FileList";
import { Icon, Spin } from "antd";
import classNames from "classnames";
import _ from "underscore";
import { useToggle } from "react-use";
import AsideLink from "../../../../CourseDetail/Group/Components/AddGroupActivityModal/Components/StepThree/Components/AsideLink";
import PreviewFileModal from "../../../../../components/PreviewFileModal";

interface GroupDetailProps {
    selectItem: GroupAnswerViewItem;
}

const GroupDetail = ({ selectItem }: GroupDetailProps) => {
    console.log(selectItem);
    const [data, { loading }] = useRequest(
        () =>
            getGroupActivityTaskHomeworkForCheck({
                activityId: selectItem.activityId,
                taskId: selectItem.taskId,
                statusId: selectItem.statusId,
                homeworkId: selectItem.homeworkId,
                groupId: selectItem.groupId
            }),
        {},
        [selectItem]
    );

    //下载文件
    const handelDownload = (fileName: string, url: string) => {
        const newUrl = `${url}?attname=${encodeURIComponent(fileName)}`;
        window.open(newUrl);
    };

    const [list, setList] = useState<TaskFileEntityListItem[]>([]);

    //预览
    const [defaultIndex, setDefaultIndex] = useState(0);

    function onPrev(id?: number) {
        togglePrev();
        const index = _.findIndex(
            data?.task.taskFileEntityList || [],
            item => item.id === id
        );

        if (index !== undefined && index !== -1) {
            setDefaultIndex(index);
        }
    }

    //预览弹窗
    const [prevShow, togglePrev] = useToggle(false);

    return (
        <div className={style.root}>
            <Spin spinning={loading}>
                <div className={style.header}>
                    <span className={style.score}>{data?.task.score}分</span>
                    <div className={style.taskName}>{data?.task.taskName}</div>
                </div>
                <div className={style.container}>
                    <div className={style.topicWrapper}>
                        <div
                            className={style.taskDetail}
                            dangerouslySetInnerHTML={{
                                __html:
                                    data?.task.taskQuestion
                                        .split("\n")
                                        .join("<br/>") || ""
                            }}
                        />
                        <div
                            className={style.fileList}
                            onClick={() =>
                                setList(data?.task.taskFileEntityList || [])
                            }>
                            {data?.task.taskFileEntityList &&
                                data.task?.taskFileEntityList.map(item => (
                                    <FileList
                                        key={item.key || item.id}
                                        fileName={item.fileName}
                                        fileSize={item?.fileSize}>
                                        <div className={style.btns}>
                                            <Icon
                                                type="download"
                                                onClick={() =>
                                                    handelDownload(
                                                        item.fileName,
                                                        item.fileUrl
                                                    )
                                                }
                                            />
                                            <Icon
                                                type="eye"
                                                onClick={() => onPrev(item.id)}
                                            />
                                        </div>
                                    </FileList>
                                ))}
                        </div>
                    </div>

                    <div className={style.content}>
                        <div className={style.tip}>小组回答</div>
                        <div
                            className={style.answer}
                            dangerouslySetInnerHTML={{
                                __html:
                                    data?.homework.taskAnswer
                                        .split("\n")
                                        .join("<br/>") || ""
                            }}
                        />
                        <div
                            className={classNames(
                                style.fileList,
                                style.answerList
                            )}
                            onClick={() =>
                                setList(data?.homework?.homeworkFileList || [])
                            }>
                            {data?.homework.homeworkFileList &&
                                data?.homework.homeworkFileList.map(item => (
                                    <FileList
                                        key={item.key || item.id}
                                        fileName={item.fileName}
                                        fileSize={item?.fileSize}>
                                        <div className={style.btns}>
                                            <Icon
                                                type="download"
                                                onClick={() =>
                                                    handelDownload(
                                                        item.fileName,
                                                        item.fileUrl
                                                    )
                                                }
                                            />
                                            <Icon
                                                type="eye"
                                                onClick={() => onPrev(item.id)}
                                            />
                                        </div>
                                    </FileList>
                                ))}
                        </div>
                    </div>
                </div>

                <PreviewFileModal
                    visible={prevShow}
                    onCancel={togglePrev}
                    selectedIndex={defaultIndex}
                    list={list || []}
                    asideRender={list.map((item, index) => (
                        <AsideLink
                            key={item.id}
                            active={index === defaultIndex}
                            onClick={() => setDefaultIndex(index)}
                            item={item}
                        />
                    ))}
                />
            </Spin>
        </div>
    );
};

export default GroupDetail;
